import { useCallback, useEffect, useRef, useState } from "react";

export const MENU_HOVER_CLOSE_MS = 5000;
export const MENU_HOVER_REWIND_MS = 200;

export function pointerCanHover() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return true;
  }

  return window.matchMedia("(hover: hover)").matches;
}

export function useHoverTimeoutClose(
  isOpen,
  onClose,
  timeoutMs = MENU_HOVER_CLOSE_MS,
) {
  const hoveredRef = useRef(false);
  const timerRef = useRef(null);
  const onCloseRef = useRef(onClose);
  const [countdownToken, setCountdownToken] = useState(0);
  onCloseRef.current = onClose;

  const stopCountdown = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    setCountdownToken(0);
  }, []);

  const startTimer = useCallback(() => {
    if (!pointerCanHover()) {
      stopCountdown();
      return;
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    setCountdownToken((n) => n + 1);
    timerRef.current = setTimeout(() => {
      timerRef.current = null;
      setCountdownToken(0);
      if (!hoveredRef.current) {
        onCloseRef.current();
      }
    }, timeoutMs);
  }, [stopCountdown, timeoutMs]);

  useEffect(() => {
    if (!isOpen) {
      hoveredRef.current = false;
      stopCountdown();
      return undefined;
    }

    startTimer();
    return stopCountdown;
  }, [isOpen, startTimer, stopCountdown]);

  return {
    countdownToken,
    timeoutMs,
    onPointerEnter: () => {
      hoveredRef.current = true;
      stopCountdown();
    },
    onPointerLeave: () => {
      hoveredRef.current = false;
      if (isOpen) {
        startTimer();
      }
    },
  };
}
